import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/css/main.scss'

const app = createApp(App)
app.config.globalProperties.$urlData = '';
app.use(ElementPlus)
app.mount('#app')
